import VocabularyModel from 'models/VocabularyModel';
import React, { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import { ModalWrapper } from '../../../components/ModalWrapper';
import { WordClassSelect } from '../../../components/selects/WordClassSelect';
import styled from 'styled-components';
import { TextareaAutosize } from '@material-ui/core';

const NewVocAI: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [wordClass, setWordClass] = useState<number | null>(null);
  const [description, setDescription] = useState('');
  const [examples, setExamples] = useState('');

  const module = useContext(ModuleContext) as VocabularyModel;
  const courseId = module.courseId;

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleCreate = async () => {
    if (wordClass === null) {
      return;
    }
    handleClose();
    await module.newVocAI(wordClass, description, examples);
  };

  const changeWordClass = (value: number | null) => {
    setWordClass(value);
  };

  if (courseId !== 0) {
    return null; // This component is only for the main vocabulary module
  }

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleOpen}>
        new AI
      </Button>
      {showModal && (
        <ModalWrapper onClose={handleClose} title={'New Voc Entry AI'} width={600} height={500}>
          <WordClassSelect isLinked={false} onChange={changeWordClass} />
          <TextAreaStyled
            placeholder={'Description'}
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            rowsMin={3}
          />
          <TextAreaStyled
            placeholder={'Examples'}
            value={examples}
            onChange={(event) => setExamples(event.target.value)}
            rowsMin={3}
          />
          <Button
            disabled={wordClass === null || description === '' || examples === ''}
            variant="contained"
            size="small"
            onClick={handleCreate}
          >
            fill
          </Button>
        </ModalWrapper>
      )}
    </>
  );
};

export default NewVocAI;

const TextAreaStyled = styled(TextareaAutosize)`
  font-size: 16px;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
`;
